import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Th, Thead, Tr } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Button, Card, CardBody, CardTitle, Col, Row, Badge } from "reactstrap";
//Import actions redux
import { deleteWorkstations } from "../../store/actions";
import BlockWorkstation from "../actionButtons/blockWorkstation";
import CancelTasksWorkstation from "../actionButtons/cancelTasksWorkstation";
import UnBlockWorkstation from "../actionButtons/unblockWorkstation";
import StrictWorkstation from "../actionButtons/strictPriority";
import UnstrictWorkstation from "../actionButtons/unstrictPriority";
import PauseWorkstation from "../actionButtons/pauseWorkstation";
import ResumeWorkstation from "../actionButtons/resumeWorkstation";

class WorkstationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      wslist: this.props.wslist,
      deleteWS: false,
      wsToDel: null,
    };
  }

  delWS() {
    this.props.deleteWorkstations(this.state.user.name, this.state.wsToDel, this.state.user.token, this.props.history);
    this.setState({ deleteWS: false });
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Estaciones de trabajo</CardTitle>
                <div className="table-responsive">
                  <table className="table table-nowrap table-centered mb-0">
                    <Thead>
                      <Tr>
                        <Th>
                          <i className="bx bx-hash"></i>
                          {this.props.t("Nombre")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Tiempo picking")}
                        </Th>
                        <Th>
                          <i className="bx bx-brush"></i>
                          {this.props.t("Actuación por defecto")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Máximo tareas")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Buffer físico")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Area rebotes")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Estrategia rebotes")}
                        </Th>
                        <Th>
                          <i className="bx bx-check-circle"></i>
                          {this.props.t("Confirmar punto externo")}
                        </Th>
                        <Th>
                          <i className="bx bx-user-pin"></i>
                          {this.props.t("Modificado por")}
                        </Th>
                        <Th>
                          <i className="bx bx-pencil"></i>
                          {this.props.t("Acciones")}
                        </Th>
                      </Tr>
                    </Thead>
                    <tbody>
                      {this.state.wslist.map((ws, key) => {
                        return (
                          <tr key={key}>
                            <td>
                              <span className="txtName">{ws.name}</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.timepicking}s</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.type}</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.maxTasks}</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.wsBuffer}</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.inboundArea}</span>
                            </td>
                            <td>
                              <span className="txtName">{ws.strategyInbound}</span>
                            </td>
                            <td>
                              {ws.outsideConfirmation === 0 ? (
                                <Badge className={"badge-soft-danger font-size-14"} pill>
                                  {this.props.t("NotConfirm")}
                                </Badge>
                              ) : (
                                <Badge className={"badge-soft-success font-size-14"} pill>
                                  {this.props.t("Confirm")}
                                </Badge>
                              )}
                            </td>
                            <td>
                              <span className="txtName">{ws.createdBy}</span>
                            </td>
                            <td>
                              <Button
                                color={"primary"}
                                className="btn btn-primary waves-effect waves-light buttonStatus wsButton"
                                onClick={() =>
                                  this.props.history.push({
                                    pathname: "/updateworkstation",
                                    state: ws,
                                  })
                                }
                              >
                                Modificar
                              </Button>
                              <Button
                                color={"danger"}
                                className="btn btn-primary waves-effect waves-light buttonStatus wsButton"
                                onClick={() =>
                                  this.setState({
                                    deleteWS: true,
                                    wsToDel: ws.name,
                                  })
                                }
                              >
                                Eliminar
                              </Button>

                              {this.state.deleteWS ? (
                                <SweetAlert
                                  showCancel
                                  title="¿Estás seguro?"
                                  cancelBtnBsStyle="danger"
                                  confirmBtnBsStyle="success"
                                  confirmBtnText={this.props.t("ok")}
                                  cancelBtnText={this.props.t("Cancel")}
                                  onConfirm={() => this.delWS()}
                                  onCancel={() => this.setState({ deleteWS: false })}
                                ></SweetAlert>
                              ) : null}
                              <CancelTasksWorkstation ws={ws.name}></CancelTasksWorkstation>
                              {parseInt(ws.wsStatus) < 2 ? (
                                <UnBlockWorkstation ws={ws.name}></UnBlockWorkstation>
                              ) : (
                                <BlockWorkstation ws={ws.name}></BlockWorkstation>
                              )}
                              {parseInt(ws.strictPriority) === 0 ? (
                                <StrictWorkstation ws={ws.name}></StrictWorkstation>
                              ) : (
                                <UnstrictWorkstation ws={ws.name}></UnstrictWorkstation>
                              )}
                              {parseInt(ws.isClosed) === 0 ? (
                                <PauseWorkstation ws={ws.name}></PauseWorkstation>
                              ) : (
                                <ResumeWorkstation ws={ws.name}></ResumeWorkstation>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { errorDeleteWs, loadingDeleteWs, ws, successDeleteWs } = state.DeleteWS;
  return {
    errorDeleteWs,
    loadingDeleteWs,
    ws,
    successDeleteWs,
  };
};
export default withRouter(
  connect(mapStateprops, { deleteWorkstations })(withNamespaces()(WorkstationsList))
);
